import { render, staticRenderFns } from "./ProductCarousel.vue?vue&type=template&id=2308e6fe&scoped=true"
import script from "./ProductCarousel.vue?vue&type=script&lang=js"
export * from "./ProductCarousel.vue?vue&type=script&lang=js"
import style0 from "./ProductCarousel.vue?vue&type=style&index=0&id=2308e6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2308e6fe",
  null
  
)

export default component.exports